import { useIntegratedActionBroadcaster } from '../../action-broadcaster/use-integrated-action-broadcaster';
import { v4 } from 'uuid';
import { useCallback } from 'react';
import { useBroadcast } from '../../common/broadcast-channel/use-broadcast';
import { useApplicationType } from './use-application-type';

export function useQuit() {
    const { isElectron, isElectronRewrite } = useApplicationType();
    const { trigger } = useIntegratedActionBroadcaster();
    const { postMessage } = useBroadcast('legacy-store-broadcast');

    return useCallback(() => {
        if (isElectron) {
            if (isElectronRewrite) {
                trigger([
                    {
                        id: v4(),
                        targetWindowType: 'ROOT',
                        type: 'QUIT_ELECTRON_APP',
                    },
                ]);
            } else {
                postMessage({ type: 'QUIT_ELECTRON_APP' });
            }
        }
    }, [trigger, postMessage, isElectron, isElectronRewrite]);
}
